import React from "react";

// React Icons
import {
    FaCheckSquare,
    FaFilter,
    FaSortAmountDownAlt,
} from "react-icons/fa";

// Components
import JobsTableSkeleton from "./JobsTableSkeleton";

const JobsTableLoader = () => {
    return (
        <div className="flex flex-col min-h-screen bg-white">
            <main className="main-content">
                <div className="content-container">
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center gap-4">
                            <h2 className="text-2xl font-bold">
                                My Applications
                            </h2>
                        </div>
                    </div>

                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center gap-4">
                            <div className="flex items-center gap-2">
                                <button
                                    className="px-3 py-1 rounded-full border-2 border-gray-300 text-gray-400 flex items-center gap-1"
                                    disabled
                                >
                                    <FaCheckSquare className="text-base" />
                                    Selected
                                </button>

                                <div className="relative">
                                    <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full border-2 border-gray-300 text-gray-400">
                                        <FaFilter className="text-base" />
                                        <select
                                            className="bg-transparent border-none focus:outline-none text-inherit"
                                            disabled
                                        >
                                            <option>All Statuses</option>
                                        </select>
                                    </div>
                                </div>

                                <button
                                    className="px-3 py-1 rounded-full border border-gray-300 text-gray-400 flex items-center gap-1"
                                    disabled
                                >
                                    <img src="/Trash 2.svg" alt="Delete" className="w-4 h-4" /> Delete
                                </button>
                            </div>
                        </div>
                        <button
                            className="px-3 py-1 rounded-full border border-gray-300 text-gray-400 flex items-center gap-1"
                            disabled
                        >
                            Sort by{" "}
                            <FaSortAmountDownAlt className="text-base" />
                        </button>
                    </div>

                    <JobsTableSkeleton />
                </div>
            </main>
        </div>
    );
};

export default JobsTableLoader;
